import React from 'react';
import { Users, CheckCircle } from 'lucide-react';
import innovaHybridImage from '../Assets/Hycross (1).png';
import innovaImage from '../Assets/Innova (1).png';
import suvImage from '../Assets/Ertiga.png';
import toyotaRumionImage from '../Assets/2023-Toyota-Rumion-1.png';
import kiaCarensImage from '../Assets/carrens.png';
import sedanImage from '../Assets/ciaz.png';
import swiftImage from '../Assets/images__3_-removebg-preview.png';
import etiosImage from '../Assets/ETIOS1-removebg-preview.png';
import fortunerImage from '../Assets/toyota_features_mob-removebg-preview.png';
import hcrossImage from '../Assets/67851_1707226826-removebg-preview.png';
import tempoImage from '../Assets/tempo5-removebg-preview.png';
import { useNavigate } from 'react-router-dom';
import luxuryImage from '../Assets/0e6573b4bab4e5af6fee5377e2f94aaf-removebg-preview.png'

const VehiclesPage = () => {
    const navigate = useNavigate();

  const vehicles = [
    {
      id: 'swift',
      name: 'Swift Dzire',
      description: 'Compact sedan perfect for city commutes',
      features: ['4+1 seater', 'Compact Size', 'Easy Parking'],
      image: swiftImage,
      badge: 'City Favorite',
      color: 'blue',
      pricing: {
        perKm: '₹11/km'
      },
      seats: '5 Seater'
    },
     {
      id: 'sedan',
      name: 'Prime Sedan - Maruti Ciaz',
      description: 'Comfortable and efficient for city rides',
      features: ['4+1 seater', 'AC Available', 'Fuel Efficient'],
      image: sedanImage,
      badge: 'Popular',
      color: 'blue',
      pricing: {
        perKm: '₹16/km'
      },
      seats: '5 Seater'
    },
    {
      id: 'etios',
      name: 'Prime Sedan-Etios',
      description: 'Reliable and fuel-efficient sedan',
      features: ['4+1 seater', 'Great Mileage', 'Economical'],
      image: etiosImage,
      badge: 'Economical',
      color: 'blue',
      pricing: {
        perKm: '₹12/km'
      },
      seats: '5 Seater'
    },
    {
      id: 'toyota-rumion',
      name: 'Toyota Rumion',
      description: 'Spacious and reliable MPV for comfortable family travel',
      features: ['7+1 seater', 'Spacious Cabin', 'Fuel Efficient'],
      image: toyotaRumionImage,
      badge: 'Family Favorite',
      color: 'blue',
      pricing: {
        perKm: '₹14/km'
      },
      seats: '7 Seater'
    },
    {
      id: 'kia-carens',
      name: 'Kia Carens',
      description: 'Premium SUV with modern features and spacious interior',
      features: ['6+1 & 7+1 seater', 'Modern Features', 'Spacious Interior'],
      image: kiaCarensImage,
      badge: 'Modern',
      color: 'blue',
      pricing: {
        perKm: '₹14/km'
      },
      seats: '7 Seater'
    },
   
    {
      id: 'fortuner',
      name: 'Toyota Fortuner',
      description: 'Premium SUV with powerful performance and luxury features',
      features: ['6+1 seater', '4x4 Available', 'Luxury Interior'],
      image: fortunerImage,
      badge: 'Premium SUV',
      color: 'blue',
      pricing: {
        perKm: '₹35/km'
      },
      seats: '7 Seater'
    },
    {
      id: 'innova-hybrid',
      name: 'Prime Suv - Toyota Hycross / Hybrid',
      description: 'Hybrid MPV with superior fuel efficiency',
      features: ['6+1 & 7+1 seater', 'AC Available', 'Premium Features'],
      image: innovaHybridImage,
      badge: 'Eco-Friendly',
      color: 'blue',
      pricing: {
        perKm: '₹22/km'
      },
      seats: '7 Seater'
    },
    {
      id: 'innova',
      name: 'SUV – Toyota Innova Crysta',
      description: 'Premium MPV for family trips',
      features: ['6+1 & 7+1 seater', 'Luxury Interior', 'Long Distance'],
      image: innovaImage,
      badge: 'Premium',
      color: 'blue',
      pricing: {
        perKm: '₹18/km'
      },
      seats: '7 Seater'
    },
    {
      id: 'suv',
      name: 'Maruti Ertiga',
      description: 'Spacious and powerful for all terrains',
      features: ['6+1 seater', 'Premium Comfort', 'All Terrain'],
      image: suvImage,
      badge: 'Recommended',
      color: 'blue',
      pricing: {
        perKm: '₹14/km'
      },
      seats: '7 Seater'
    },
    {
      id: 'hcross',
      name: 'Luxury Urbania',
      description: 'Ultra-luxury van for groups',
      features: ['10, 12, 13, 14 and 17 seater', 'Ultra Luxury', 'Group Travel'],
      image: hcrossImage,
      badge: 'Luxury',
      color: 'blue',
      pricing: {
        perKm: '₹45/km'
      },
      seats: '17 Seater'
    },
    {
      id: 'tempo',
      name: 'Tempo Traveller',
      description: 'Perfect for large groups',
      features: ['12+1 seater - A/C & Non A/C', 'Group Friendly', 'Tourist Special'],
      image: tempoImage,
      badge: 'Best Value',
      color: 'blue',
      pricing: {
        perKm: '₹30/km'
      },
      seats: '13 Seater'
    },
    {
      id: 'luxury',
      name: 'Premium Buses',
      description: 'Premium cars for special occasions',
      // price: '₹60',
      features: ['21, 30, 50 Seater- A/C & Non A/C', 'VIP Service', 'Special Events'],
      image: luxuryImage,
      badge: 'Elite',
      color: 'blue',
      pricing: {
        perKm: '₹60/km',
        // perHour: '₹1200/hour',
        // minCharge: '₹1000'
      },
      seats: '50 Seater'
    }
  ];

  const handleBookNow = (vehicle) => {
    // Navigate to booking form with vehicle data
    navigate('/booking-form', {
      state: {
        vehicle: vehicle,
        // You can also include additional data if needed
        tripData: null, // or pass actual trip data if available
        preFilledData: null // or pass pre-filled data if available
      }
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold mb-4 text-gray-800">Our Fleet – Your Ride, Your Way</h1>
          <p className="text-xl text-gray-600">
          We’ve got a car for every journey! Whether you need a quick city ride, a family outstation trip, or an airport drop, My Journey Cabs offers a variety of cars to suit your needs and budget.
Our vehicles are clean, comfortable, and always ready — just like our friendly drivers who ensure your ride is safe and enjoyable.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {vehicles.map((vehicle) => (
            <div 
              key={vehicle.id} 
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-blue-100"
            >
              {/* Image Container */}
              <div className="h-48 flex items-center justify-center bg-gradient-to-br from-yellow-100 to-yellow-200 p-4">
                <img 
                  src={vehicle.image} 
                  alt={vehicle.name}
                  className="h-full w-full object-contain"
                />
              </div>
              
              <div className="p-6">
                <div className="flex justify-between items-start mb-4">
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-800 mb-1">
                      {vehicle.name}
                    </h3>
                    <p className="text-gray-600 text-sm mb-2">
                      {vehicle.description}
                    </p>
                  </div>
                  <div className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                    <Users size={16} className="inline mr-1" />
                    {vehicle.seats}
                  </div>
                </div>
                
                {/* Features */}
                <div className="mb-4">
                  {vehicle.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center text-gray-600 mb-2">
                      <CheckCircle size={16} className="text-blue-500 mr-2 flex-shrink-0" />
                      <span className="text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
                
                {/* Pricing and CTA */}
                <div className="flex justify-between items-center pt-4 border-t border-gray-200">
                  <div>
                    <span className="text-1xl text-gray-600 text-sm">Starts from</span>
                    <span className="text-2xl font-bold text-blue-600">
                      {vehicle.pricing.perKm}
                    </span>
                  </div>
                  <button 
                    onClick={() => handleBookNow(vehicle)}
                    className="bg-gray-900 text-white px-6 py-2 rounded-full font-semibold hover:bg-blue-600 transition-colors duration-300 text-sm"
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VehiclesPage;